import React, { Suspense } from "react";
import ReactDOM from 'react-dom/client';
import { HashRouter } from "react-router-dom";
import "./i18next";
import './css/index.css';
import App from './components/app';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from "./components/errorboundary";
window.React = React;
window.ReactDOM = ReactDOM;

ReactDOM.createRoot(
  document.getElementById('root')
)
  .render(
    
    <HashRouter>
      <Suspense fallback="loading">
        <App />
      </Suspense>
    </HashRouter>
  );

reportWebVitals();

